export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-problem-1.4d403902.png";